import { render, staticRenderFns } from "./ModalMessageApp.vue?vue&type=template&id=f1674272&scoped=true&"
import script from "./ModalMessageApp.vue?vue&type=script&lang=ts&"
export * from "./ModalMessageApp.vue?vue&type=script&lang=ts&"
import style0 from "./ModalMessageApp.vue?vue&type=style&index=0&id=f1674272&prod&lang=scss&scoped=true&"
import style1 from "./ModalMessageApp.vue?vue&type=style&index=1&id=f1674272&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1674272",
  null
  
)

export default component.exports